import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class FolderPermissionModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (FolderPermissionModel._instance == null) FolderPermissionModel._instance = new FolderPermissionModel(authManager);
        return FolderPermissionModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'core/folder-permissions');

        this.entityName = 'core.FolderPermission';
        this.privileges = {
            create: [["adminFileStorage"],["useFileStorage"]],
            read: [["adminFileStorage"],["useFileStorage"]],
            update: [["adminFileStorage"],["useFileStorage"]],
            delete: [["adminFileStorage"],["useFileStorage"]],
        };

        this.label = 'Folder Permission';
        this.setLabel = 'Folder Permissions';

        this.browser = {
            name: 'default-core-folderpermission-browser',
            moduleName: 'default-core-folderpermission-browser',
            moduleTitle: 'Folder Permissions',
            moduleStateSlotName: 'default-core-folderpermission-browser',
        };

        this.editor = {
            name: 'default-core-folderpermission-editor',
            moduleName: 'default-core-folderpermission-editor',
            moduleTitle: 'Folder Permission',
            moduleStateSlotName: 'default-core-folderpermission-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'uid',
                type: 'string',
                persistent: true,
                label: 'Unique ID',
                required: true,
                readOnly: true,
            },
            {
                name: 'permissionsFolderId',
                type: 'Folder',
                persistent: true,
                label: 'Folder',
                inEditor: true,
            },
            {
                name: 'userId',
                type: 'User',
                persistent: true,
                label: 'User',
                inEditor: true,
            },
            {
                name: 'userLabel',
                type: 'string',
                persistent: false,
                label: 'User',
                distinctLabel: 'User (text)',
                readOnly: true,
                inBrowser: true,
            },
            {
                name: 'roleId',
                type: 'Role',
                persistent: true,
                label: 'Role',
                inEditor: true,
            },
            {
                name: 'roleName',
                type: 'string',
                persistent: false,
                label: 'Role',
                distinctLabel: 'Role (text)',
                readOnly: true,
                inBrowser: true,
            },
            {
                name: 'permissions',
                type: 'int',
                persistent: true,
                label: 'Permissions',
                inEditor: true,
            },
            {
                name: 'irrevocablePermissions',
                type: 'int',
                persistent: true,
                label: 'Irrevocable Permissions',
            },
        ];

    }

}
